import type { ProductPageLoaderData } from '~/routes/_app.product.$urlSegment';

type Product = ProductPageLoaderData['product'];

export interface GroupedFacet {
    ID: number;
    Label: string;
    IsGeneral: boolean;
    options: string[];
}

/**
 * Approved, detail-page-enabled facet options grouped by facet — the same
 * filter + grouping the legacy `DetailsTab` applies, extracted as a pure
 * helper so the revamp accordion can reuse it without the aria styling.
 */
export const groupApprovedFacetOptions = (
    facetOptions: Product['FacetOptions'],
): GroupedFacet[] =>
    facetOptions
        .filter(
            (option) =>
                option.Approved &&
                !option.Facet.IsHidden &&
                !option.Facet.IsDetailPageDisabled,
        )
        .reduce<GroupedFacet[]>((acc, curr) => {
            const {
                Facet: { ID, Label, IsGeneral },
                Name,
            } = curr;
            const facet = acc.find((entry) => entry.ID === ID);
            if (facet) {
                facet.options.push(Name);
            } else {
                acc.push({ ID, Label, IsGeneral, options: [Name] });
            }
            return acc;
        }, [])
        .sort((a, b) => a.ID - b.ID);
